import React from 'react';

const PurchasedPeopleIcon = (props: any) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 17.8987V15.8649H21C21.431 15.8649 21.812 15.5853 21.948 15.1694L23.948 9.06809C24.123 8.53525 23.84 7.95969 23.316 7.78173C22.8759 7.63228 11.0958 4.85984 7.22186 3.94936C6.59434 3.80188 6 4.2796 6 4.92422V18.0858C4.839 18.5078 4 19.6254 4 20.9494C4 22.6313 5.346 24 7 24C8.654 24 10 22.6313 10 20.9494C10 20.5904 9.928 20.2518 9.815 19.9325H18.185C18.072 20.2518 18 20.5904 18 20.9494C18 22.6313 19.346 24 21 24C22.654 24 24 22.6313 24 20.9494C24 19.2674 22.654 17.8987 21 17.8987H8Z" />
  </svg>
);

export default PurchasedPeopleIcon;
